function isStringOrNumber(value) {
  return typeof value === 'string' || typeof value === 'number';
}

export default isStringOrNumber;
